<div class="smartjac-main">
	<section class="new-auth-section">
		<section class="bg-onboarding">
			<div class="signin-page" data-theme='dark'>
				<div class="signin-inner" data-theme='dark'>
					<div class="row">
						<div class="col-lg-6 d-flex flex-column left-signin-inner">
							<!-- <div>
								<img class="auth-trance-logo" src="" alt="">
							</div> -->
							<div class="logo mt-auto mx-auto pb-5">
								<img class="img-logo" src="../../../assets/images/smartjac/logo/SquareLogo.png">
							</div>
							<!-- <div class="ml-3 mb-3 t-powered-parent">
								<span class="mr-2">{{ "Powered by" | translate}}</span> <img class="t-powered-logo" src="images/jcius.png" alt="">
							</div> -->
						</div>
						<div class="col-lg-6 right-signin-inner">
							<!-- <div class="d-flex justify-content-end mt-3 mr-3  main-lang-dropdown">
								<select class="px-2 t-input auth-lang-dropdown" style="border-radius: 30px; height: 35px; outline: none;" [(ngModel)]="langSelected" (ngModelChange)="changeLanguage()">
									<option value="en">ENG</option>
									<option value="ru">RU</option>
									<option value="mr">MR</option>      
								</select>
								<i class="fa fa-angle-down "></i>
							</div> -->
							<div>
								<form [formGroup]="resetPassForm" (ngSubmit)="onResetPass()">
									<div class="createaccount-form">
	
										<div class="form-group mb-4">
											<label for="exampleInputEmail1" class="mb-0">{{ "Password" | translate}}</label>
											<input type="password" [ngClass]="{'submitted': submitted}" class="form-control onboarding-form-input" formControlName="password">
											<div>
												<span class="help-block ng-invalid text-danger" *ngIf="(!f.password.valid && !f.password.pristine) || (f.password.errors && submitted)">
													<span class="small" *ngIf="f.password.errors.required">
														{{ "Password is required" | translate}}!
													</span>
												</span>
											</div>
										</div>
	
										<div class="form-group">
											<label for="exampleInputEmail1" class="mb-0">{{ "Repeat Password" | translate}}</label>
											<input type="password" [ngClass]="{'submitted': submitted}" class="form-control onboarding-form-input" formControlName="confirmPassword">
											<span class="help-block ng-invalid text-danger mb-0" *ngIf="(!f.confirmPassword.valid && !f.confirmPassword.pristine) || (f.confirmPassword.errors && submitted)">
												<span class="small" *ngIf="f.confirmPassword.errors.required">
													{{ "Confirm Password is required" | translate}}!
												</span>
											<span class="small" *ngIf="f.confirmPassword.errors.mustMatch">
												{{ "Passwords must match" | translate}}
											</span>
											</span>
											<button class="btn btn-block signin-inner-btn outline" type="submit"> {{ "Reset Password" | translate}}</button>
											<button class="btn btn-block signin-inner-cancel-btn mt-3 outline" routerLink="/signin" type="submit">{{ "Cancel" | translate}}</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</section>
</div>